import { type QuoteResponse } from '@7kprotocol/sdk-ts';
import { ClmmPoolUtil } from '@cetusprotocol/cetus-sui-clmm-sdk';
import { K7Aggregator } from '@libs/7k.provider';
import { BN, Decimal } from 'parrot-sui-sdk';
import { useEffect, useState } from 'react';

export const useComputeSwapAggregator = (options: {
  amount: string;
  tokenInType: string;
  tokenOutType: string;
  sqrt_price: string | undefined;
  a2b: boolean;
  lowerIndex: number | undefined;
  upperIndex: number | undefined;
  isRatio?: boolean;
}) => {
  const {
    amount,
    tokenInType,
    tokenOutType,
    sqrt_price,
    lowerIndex,
    upperIndex,
    a2b,
    isRatio = true,
  } = options;

  const [loading, setLoading] = useState(false);
  const [aggregatorRoute, setAggregatorRoute] = useState<QuoteResponse>();

  const bestRoute = async () => {
    if (
      !amount ||
      amount === '0' ||
      !sqrt_price ||
      lowerIndex === undefined ||
      upperIndex === undefined
    ) {
      setAggregatorRoute(undefined);
      return;
    }
    let swapAmount = amount;

    if (isRatio) {
      const { ratioA, ratioB } = ClmmPoolUtil.calculateDepositRatioFixTokenA(
        lowerIndex,
        upperIndex,
        new BN(sqrt_price),
      );

      swapAmount = new Decimal(amount).mul(a2b ? ratioB : ratioA).toFixed(0);
      if (swapAmount === '0') {
        setAggregatorRoute(undefined);
        return;
      }
    }

    try {
      const quoteResponse = await K7Aggregator.findBestRoute({
        tokenInType: tokenInType,
        tokenOutType: tokenOutType,
        amountIn: swapAmount,
      });
      setAggregatorRoute(quoteResponse);
    } catch (err) {}
  };

  useEffect(() => {
    let timer: NodeJS.Timeout | undefined;
    let loopTimer: NodeJS.Timeout | undefined;
    let isGo = false;

    const loop = async () => {
      await bestRoute();
      if (isGo) {
        return;
      }

      loopTimer = setTimeout(() => {
        loop();
      }, 30000);
    };

    setLoading(true);
    setAggregatorRoute(undefined);
    timer = setTimeout(async () => {
      if (amount && tokenInType && tokenOutType) {
        await loop();
      } else {
        setAggregatorRoute(undefined);
      }
      setLoading(false);
    }, 300);

    return () => {
      clearTimeout(timer);
      clearTimeout(loopTimer);
      isGo = true;
    };
  }, [amount, tokenOutType, tokenInType, sqrt_price, lowerIndex, upperIndex]);

  return {
    aggregatorRoute,
    loading,
  };
};
